import { useMutation } from '@tanstack/react-query';

import { MembershipIdentifier } from 'src/features/membership/types';
import { MembershipIdentifierFormSchemaValues } from 'src/features/membershipType/formSchema';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/memberships/membership/:membershipId/identifiers/:identifierId/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    parkingId: string;
    data: MembershipIdentifierFormSchemaValues;
    membershipId: string;
    identifierId: string;
    is_validated?: boolean;
}
const mutationFn = ({ parkingId, membershipId, identifierId, data }: DTO): Promise<MembershipIdentifier> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, membershipId, identifierId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateIdentifier };
